import { Stack } from "@similarweb/ui-components/foundations";

import type { GaTriggerContainerProps, IStreamsSelectProps } from "app/modules/ga-connect";
import { GaStreamsSelect, GaTriggerContainer } from "app/modules/ga-connect";

import { type IPropertyNameFieldProps, PropertyNameField } from "./PropertyNameField";

type GaTriggerInitialSettings = GaTriggerContainerProps["initialSelection"];

export interface IGaSettingsProps
    extends
        IStreamsSelectProps,
        Omit<GaTriggerContainerProps, "children" | "initialSelection">,
        Pick<IPropertyNameFieldProps, "propertyName">,
        GaTriggerInitialSettings {
    isDisabled?: boolean;
}

export const GaSettings = ({
    connectionId,
    isDisabled,
    onStreamChange,
    propertyId,
    propertyName,
    streamId,
    ...other
}: IGaSettingsProps) => (
    <Stack gap="24px">
        {isDisabled ? (
            <PropertyNameField
                propertyName={propertyName}
                isDisabled
            />
        ) : (
            <GaTriggerContainer
                {...other}
                initialSelection={{ connectionId, propertyId, streamId }}
            >
                {({ open, isLoading }) => (
                    <PropertyNameField
                        isLoading={isLoading}
                        onClick={open}
                        propertyName={propertyName}
                    />
                )}
            </GaTriggerContainer>
        )}
        <GaStreamsSelect
            connectionId={connectionId}
            isDisabled={isDisabled}
            onStreamChange={onStreamChange}
            propertyId={propertyId}
            streamId={streamId}
        />
    </Stack>
);
